module.exports = __webpack_public_path__ + "img/cabeza_danger.cd016152.svg";